import React from 'react';

const Copyright = ({isBigScreen}) => {
    return (
        <p style={{fontSize: "14px"}}>© Copyright ParagonCorp. All Rights Reserved.</p>
    );
};

export default Copyright;
